export default __webpack_public_path__ + "static/media/foundation.57b470d6.png";